import { COMPLAINT_BOOK } from "configs/links";
import React from "react";
import styled from "styled-components";
import { breakpoints } from "themes/breakpoints";
import Link from "ui/Link";
import Body from "ui/Text/Body";

interface Props {
  className?: string;
}

const CopyrightSection: React.FC<Props> = ({ className }) => {
  return (
    <Text variant="body7" color="secondary" className={className}>
      {`© DataRede ${new Date().getFullYear()} - Todos os direitos reservados`}
      <br />
      <Link target="_blank" href={COMPLAINT_BOOK}>
        Elogios, Sugestões e Reclamações
      </Link>
    </Text>
  );
};

export default CopyrightSection;

const Text = styled(Body)`
  @media (min-width: ${breakpoints.md}) {
    text-align: center;
  }
`;
